import API from 'services/api';

export const getUnitOccupancy = (unitOccupancyId: string) =>
  API.get(`/api/accommodation/unit-occupancy/${unitOccupancyId}`);
